import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import ItemSelectionStyled from '../../../asset/styled/deductions/ItemSelectionStyled';
import titleImg from '../../../asset/img/itemSelection_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';
import ItemListSection from './ItemListSection';
import SlideDialogV from '../../../components/common/SlideDialogV';
import { updateHtm159 } from './itemSelectionSlice';
const ItemSelection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/itemSelection');

  return (
    <ItemSelectionStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />
      <ItemListSection />
    </ItemSelectionStyled>
  );
};

export default ItemSelection;
